import React, { Component } from 'react';
import _ from 'lodash';
import { connect } from 'react-redux';
import { Helmet } from 'react-helmet-async';
import { pageTitle } from '../../../util/pageTitles';

import NoData from '../../../components/NoData/NoData';
import CardPlaceholder from '../../../components/CardPlaceholder';
import { setChart, saveConfig, updateLineChart, updateAvgChart, updateBlockersChart } from '../../../components/Filter/FilterActions';
import { setPageName } from './../../App/AppActions';
import { getData } from '../CTAActions';

import Filter from '../../../components/Filter/Filter';
import { DatePicker, Options } from '../../../components/Filter/components';
import CTADetailsAccordion from '../../../components/DetailsAccordion/CTADetailsAccordion';
import WipAvgAge from '../components/WipAvgAge';
import DailyWIP from '../components/DailyWIP';
import BlockersStats from '../../Common/components/BlockersStats';

import { 
  trackTeamDashboardView, 
  trackChartPointDetailsView,
  trackHowToOpened 
} from '../../../util/mixpanel';

import CTAChart from './../components/CTAChart';
import ChartDownloadMenu from '../../../components/ChartDownloadMenu';
import chartUtils from '../../../util/chartUtils';

export class CTA extends Component {
  constructor(props) {
    super(props);

    this.state = {
      data: {
        series: [],
        categories: [],
        healthZones: []
      },
      selectedPoint: {},
      width: 900,
      height: 900
    };

    this.handleChange = this.handleChange.bind(this);
    this.handlePointClick = this.handlePointClick.bind(this);
    this.contentRef = React.createRef();

    props.dispatch(setPageName('Aging Chard'));
  }

  componentDidMount() {
    if (this.props.dashboard && this.props.dashboard._id && this.props.dataIsLoading === false) {
      this.props.setChart('cta');

      trackTeamDashboardView('cta');
    }

    if (this.props.data) {
      this.setDataPoint();
    }
    this.handleResize();
    window.addEventListener("resize", this.handleResize);
  }

  componentDidUpdate(prevProps) {
    if (
      (prevProps.dataHash != this.props.dataHash ||
        prevProps.hash != this.props.hash ||
        prevProps.enabledColors != this.props.enabledColors) &&
      this.props.dataIsLoading === false
    ) {
      this.handleChange();
    }

    if (prevProps.data !== this.props.data) {
      this.setDataPoint();
    }

    if (
      this.props.data &&
      !!this.props.data.length &&
      !this.props.dataIsLoading &&
      prevProps.dates.daysFromStart !== this.props.dates.daysFromStart
    ) {
      this.setDataPoint(this.props.dates.daysFromStart);
    }
  }

  componentWillUnmount() {
    window.removeEventListener("resize", this.handleResize);
  }

  setDataPoint(day = -1) {
    let data = this.props.data[0];

    if (day > -1 && day < this.props.data.length) {
      const index = this.props.data.length - day - 1;
      data = this.props.data[index];

      this.setState({
        selectedPoint: {}
      });
    }

    if (data) {
      this.setState({
        data
      });
    }
  }

  handleChange(force) {
    if (force || !this.props.dataIsLoading) {
      this.setState({
        selectedPoint: {}
      });
      this.props.getData();
    }
  }

  handlePointClick(point) {
    this.setState({
      selectedPoint: point
    });

    trackChartPointDetailsView('cta', true);
  }

  handleSegmentClick = (segmentData) => {
    const series = (this.state.data && this.state.data.series) || [];
    const agingPoints = _.keyBy(_.flatMap(series, 'data'), point => point.card && point.card.id);
    const points = segmentData.items.map(item => {
      const point = agingPoints[item.id];
      return point
        ? { card: point.card, details: point.details, color: point.color, date: point.date }
        : { card: { name: item.name }, details: [] };
    });

    this.setState({
      selectedPoint: {
        duration: `${segmentData.count} item${segmentData.count !== 1 ? 's' : ''} in "${segmentData.name}"`,
        points
      }
    });

    trackChartPointDetailsView('cta', true);
  };

  handleResize = () => {
    if (this.contentRef && this.contentRef.current) {
      this.setState({
        width: this.contentRef.current.offsetWidth,
        height: this.contentRef.current.offsetHeight
      });
    }
  }

  trackHowToCTAOpen() {
    trackHowToOpened('cta');
  }

  getBlockersFlags() {
    const { app, dashboard } = this.props;
    const showBlockers = app === 'trello' || app === 'azure' || app === 'jira' || (app === 'file' && !dashboard.isAzure);
    const blockersDisabled =
      dashboard.application === 'jira' && dashboard.isBusiness && !dashboard.selectedBlockedFlag ||
      dashboard.application === 'trello' &&  !dashboard.selectedBlockedFlag || 
      dashboard.application === 'azure' && !dashboard.selectedBlockedFlag;
    return { showBlockers, blockersDisabled };
  }

  handleCloseBlockers = () => {
    this.props.closeBlockers();
    this.props.saveConfig();
  };

  handleCloseWip = () => {
    this.props.closeWip();
    this.props.saveConfig();
  };

  handleCloseWipAvgAge = () => {
    this.props.closeWipAvgAge();
    this.props.saveConfig();
  };

  render() {
    const tooltip = (
      <div className="more_info_tooltip">
        <div className="more_info-inner">
          <h4>Aging Chart</h4>
          <p>Each dot is an in-progress item, positioned by its workflow state and age. Coloured zones show age percentiles from past items in that state.</p>
          <p><b>Look for:</b> dots in red zones, which indicate ages above the highest selected percentile.</p>
          <a
            href={`https://getnave.com/aging-chart`}
            target="_blank"
            onClick={this.trackHowToCTAOpen}
            onAuxClick={this.trackHowToCTAOpen}
            className='more_info-link'
            >
              Learn more →
          </a>
        </div>
      </div>
    );

    const totalItems = !this.state.data ? 0 : _.reduce(this.state.data.series, (p, c) => {
      return p + (c.data && c.data.length || 0);
    }, 0);
    const leftAdjust = (+this.props.lineChart) * 272 + (+this.props.avgChart) * 272;
    const bounds = { left: - leftAdjust, top: 112, right: this.state.width - 320 - leftAdjust, bottom: this.state.height - 290 };
    const { showBlockers, blockersDisabled } = this.getBlockersFlags();
    
    const blockersStats = showBlockers && this.props.data && !!this.props.data.length && this.state.data.stats;

    return (
      <div className="content-wrap" >
        <Helmet>
          <title>{pageTitle(`Aging Chart${this.props.dashboard ? ' | ' + this.props.dashboard.name : ''}`)}</title>
        </Helmet>
        <Filter totalItems={totalItems} dateSlider enablePercentiles enableMarkBlocked enableHealthZones enableBreakdownBy={!blockersDisabled} breakdownByText={'Group blockers by'} enableWipBreakdownBy timeunit enableShowColumns />
        <div className="chart_box_view">
          <div className="dashboard_head">
            <div className="flex-layout">
              <h1>
                Aging Chart
              </h1>
              <div className="more_info_content">
                <span className="more_info"></span>
                {tooltip}
              </div>
            </div>
            <div className="button_tools">
              <Options
                showAvgChart
                showLineChart
                showBlockers={showBlockers}
                blockersDisabled={blockersDisabled}
                options={{
                  avgChartTooltip: 'WIP average age',
                  lineChartTooltip: 'WIP'
                }}
              />
              <DatePicker />
            </div>
          </div>
          <div className="dashboard_details" ref={this.contentRef}>
            {/* the card shows only with its toolbar button: offered for the app and enabled by a blocked flag */}
            {this.props.blockersChart && showBlockers && !blockersDisabled && (this.state.data && blockersStats ? (
              <BlockersStats id="stats" data={blockersStats} focusable />
            ) : (
              <CardPlaceholder title="Blockers" shape="table" loading={this.props.isLoading} onClose={this.handleCloseBlockers} />
            ))}
            {this.props.lineChart && (this.state.data && chartUtils.hasWorkItems(this.props.data) ? (
              <DailyWIP
                day={this.props.dates.daysFromStart}
                data={this.props.data}
                dayData={this.state.data}
                dateFormat={this.props.dateFormat}
                exportDate={this.props.wipBreakdownType === 'pie' ? this.state.data.date : undefined}
                widget="dwip"
                onSegmentClick={this.handleSegmentClick}
              />
            ) : (
              <CardPlaceholder title={this.props.wipBreakdownType === 'pie' ? 'WIP breakdown' : 'WIP'} shape={this.props.wipBreakdownType === 'pie' ? 'pie' : 'line'} loading={this.props.isLoading} onClose={this.handleCloseWip} />
            ))}
            {this.props.avgChart && (this.state.data && chartUtils.hasWorkItems(this.props.data) ? (
              <WipAvgAge
                day={this.props.dates.daysFromStart}
                data={this.props.data}
                dateFormat={this.props.dateFormat}
                widget="waa"
              />
            ) : (
              <CardPlaceholder title="WIP average age" shape="line" loading={this.props.isLoading} onClose={this.handleCloseWipAvgAge} />
            ))}
          </div>
          <div className="chart_row">
            <div className="diagram_details">
              <ChartDownloadMenu chartId="CTA" />
              <CTAChart id="CTA" data={this.state.data} exportDate={this.state.data.date} onPointClick={this.handlePointClick} isPointSelected={!!(this.state.selectedPoint && this.state.selectedPoint.points && this.state.selectedPoint.points.length)} blockers={this.props.blockers} />
              <NoData show={this.state.data.series && !this.state.data.series.length} loading={this.props.isLoading} />
            </div>
            <CTADetailsAccordion id="details-accordion" bounds={bounds} data={this.state.selectedPoint} onClose={() => this.setState({ selectedPoint: {} })} blockedTime={this.props.blockedTime} blockers={this.props.blockers} />
          </div>
        </div>
      </div>
    );
  }
}

const mapDispatchToProps = dispatch => {
  return {
    setChart: name => dispatch(setChart(name)),
    getData: () => dispatch(getData()),
    closeBlockers: () => dispatch(updateBlockersChart(false, 'cta')),
    closeWip: () => dispatch(updateLineChart(false, 'cta')),
    closeWipAvgAge: () => dispatch(updateAvgChart(false, 'cta')),
    saveConfig: () => dispatch(saveConfig())
  };
};

const mapStateToProps = state => {
  return {
    wipBreakdownType: state.filters.cta.wipBreakdownType || 'line',
    dateFormat: state.filters.dateFormat,
    dates: state.filters.dates,
    enabledColors: state.filters.enabledColors,
    blockedTime: state.filters.cta.blockedTime,
    hash: state.filters.cta.hash,
    lineChart: state.filters.cta.lineChart,
    avgChart: state.filters.cta.avgChart,
    blockersChart: state.filters.cta.blockersChart,
    blockers: state.filters.cta.blockers,
    data: state.cta.data,
    isLoading: state.cta.isLoading,
    dashboard: state.dashboards.selected,
    dataIsLoading: state.app.isLoading,
    dataHash: state.app.dataHash,
    app: state.app.app
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(CTA);
